import { ToTypeIdPipe } from './toTypeId.pipe';
import { LocalDatePipe } from './local-date.pipe';
import { AgePipe } from './age.pipe';
import { YoutubeCaptionsPipe } from './youtube-captions.pipe';
import { TimeAgoPipe } from './time-ago.pipe';
import { RefMinMaxPipe } from './ref-min-max.pipe';
import { ChapterImagePipe } from './chapter-image.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { DecimalPlacesPipe } from './decimal-places.pipe';
import { TransformUnitsPipe } from './transform-units.pipe';
import { ColorizePipe } from './colorize.pipe';

export const pipes = [
  ToTypeIdPipe,
  LocalDatePipe,
  AgePipe,
  YoutubeCaptionsPipe,
  TimeAgoPipe,
  RefMinMaxPipe,
  ChapterImagePipe,
  SafeHtmlPipe,
  DecimalPlacesPipe,
  TransformUnitsPipe,
  ColorizePipe,
];

export {
  ToTypeIdPipe,
  LocalDatePipe,
  AgePipe,
  YoutubeCaptionsPipe,
  TimeAgoPipe,
  RefMinMaxPipe,
  ChapterImagePipe,
  SafeHtmlPipe,
  DecimalPlacesPipe,
  TransformUnitsPipe,
  ColorizePipe,
};
